<template>
  <div class="content content-fixed content-auth">
    <div v-if="groupChooser.show">
      <div style="overflow: auto; max-height: calc(100vh - 95px)">
        Байгууллага тохируулах
        <ul class="list-group">
          <li
            @click="setOrg(g)"
            v-for="(g, i) in groupChooser.list"
            :key="i"
            class="list-group-item d-flex align-items-center"
          >
            <div style="min-width: 45px">
              <img
                :src="`logos/${g.id}.png`"
                class="wd-30 rounded mg-r-15"
                alt
              />
            </div>
            <div>
              <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">{{ g.name }}</h6>
              <span class="d-block tx-11 text-muted">{{ g.domain }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div v-else class="container" style="max-width: 1140px !important">
      <div
        class="
          media
          align-items-stretch
          justify-content-center
          ht-100p
          pos-relative
        "
      >
        <div class="media-body align-items-center d-none d-lg-flex">
          <div
            class="mx-wd-1200"
            v-if="$store.state.app.activeGroup.id == 9132"
          >
            <div
              id="carouselExample2"
              class="carousel slide"
              data-ride="carousel"
            >
              <div class="carousel-inner">
                <div
                  class="carousel-item"
                  :class="{ active: activeCarousel == i }"
                  v-for="(t, i) in 3"
                  :key="i"
                >
                  <img
                    :src="`https://res.gosmart.mn/media/bg/suis_lms_${t}.jpg?w=800`"
                    class="rounded"
                  />
                </div>
              </div>
              <a
                class="carousel-control-prev"
                @click="carouselChange(-1)"
                role="button"
              >
                <span class="carousel-control-prev-icon" aria-hidden="true">
                  <feather
                    type="chevron-left"
                    class="wd-20-f ht-20-f"
                  ></feather>
                </span>
                <span class="sr-only">Previous</span>
              </a>
              <a
                class="carousel-control-next"
                @click="carouselChange(1)"
                role="button"
              >
                <span class="carousel-control-next-icon" aria-hidden="true">
                  <feather
                    type="chevron-right"
                    class="wd-20-f ht-20-f"
                  ></feather>
                </span>
                <span class="sr-only">Next</span>
              </a>
            </div>
          </div>
          <div class="mx-wd-600" v-else>
            <img
              v-if="coverObj.rdy"
              :src="coverObj.url"
              class="img-fluid"
              alt
            />
            <img
              v-else-if="
                $store.state.app.activeGroup.bgLogin != undefined &&
                $store.state.app.activeGroup.bgLogin != ''
              "
              :src="$store.state.app.activeGroup.bgLogin"
              class="img-fluid"
              alt
            />
            <img v-else src="assets/img/img15.png" class="img-fluid" alt />
          </div>
          <!-- <div class="pos-absolute b-0 l-0 tx-12 tx-center">
            <a target="_blank" href="https://www.gosmart.mn">Powered by Dynamic Platform</a>
          </div> -->
        </div>
        <!-- media-body -->
        <div class="sign-wrapper mg-lg-l-50 mg-xl-l-60">
          <!-- todo form @submit="login" -->
          <div class="wd-100p">
            <div class="wd-100p">
              <h3 class="tx-color-01 mg-b-5">Нэвтрэх</h3>
              <p
                v-if="$store.state.app.activeGroup.id == 9132"
                class="tx-color-03 tx-16 mg-b-40"
              >
                Багш эсвэл Оюутны кодоо ашиглан нэвтэрнэ үү.
              </p>
              <p
                v-else-if="
                  $store.state.app.activeGroup.id == 9241 ||
                  $store.state.app.activeGroup.id == 9249 || 
                  $store.state.app.activeGroup.id == 9307
                "
                class="tx-color-03 tx-16 mg-b-40"
              ></p>
              <p
                v-else-if="$store.state.app.activeGroup.id == 9254"
                class="tx-color-03 tx-16 mg-b-40"
              >
                Бүртгүүлсэн мэдээллээ оруулна уу
              </p>
              
              <div v-else-if="$store.state.app.activeGroup.id == 9298" class="alert alert-info">
                <p class="tx-13 lh-1 mg-b-5">
                  Доорхи системүүдэд бүртгэлтэй бол өөрийн үүсгэсэн бүртгэлээрээ нэвтрэн орно уу !
                </p>
                <ul class="mg-l-20 mg-b-0">
                  <li class="lh-1" :title="d.desc" v-for="(d, di) in stfAppDomains" :key="di">{{ d.url }}</li>
                </ul>
              </div>
              <p v-else class="tx-color-03 tx-16 mg-b-40">
                Динамик аккаунт ашиглан нэвтэрнэ үү.
              </p>

              <div class="form-group">
                <label v-if="$store.state.app.activeGroup.id == 9132"
                  >Багш эсвэл Оюутны код эсвэл И-мэйл хаяг</label
                >
                <label
                  v-else-if="
                    $store.state.app.activeGroup.id == 9241 ||
                    $store.state.app.activeGroup.id == 9249
                  "
                  >Домэйн</label
                >
                <label v-else>Хэрэглэгчийн нэр эсвэл И-мэйл хаяг</label>
                <input
                  v-on:keyup="checkEnter"
                  tabindex="1"
                  v-model="loginModel.username"
                  type="text"
                  class="form-control"
                  :placeholder="`${getLoginPlaceHolder()}`"
                />
              </div>
              <div class="form-group">
                <div class="d-flex justify-content-between mg-b-5">
                  <label class="mg-b-0-f">Нууц үг</label>
                  <!-- <a tabindex="4" class="tx-13">Нууц үг мартсан?</a> -->
                  <router-link to="/forgot" class="tx-13"
                    >Нууц үг мартсан?</router-link
                  >
                </div>
                <input
                  v-on:keyup="checkEnter"
                  tabindex="2"
                  v-model="loginModel.password"
                  type="password"
                  class="form-control"
                  placeholder="Нууц үгээ оруулна уу"
                />
              </div>
              <button
                @click="login"
                tabindex="3"
                type="submit"
                class="btn btn-brand-02 btn-block"
              >
                Нэвтрэх
              </button>
              <!-- {{ $store.state.app.activeGroup.id }} -->
              <template v-if="$store.state.app.activeGroup.register == true">
                <template v-if="$store.state.app.activeGroup.id == 9311">
                  <div class="divider-text">шинээр бүртгүүлэх төрөл сонгоно уу</div>
                  <div class="">
                    <button @click="openSimpleRegForm()" class="btn btn-white btn-block">Бүртгүүлэх</button>
                    <button @click="$router.push({name: 'register'})" class="btn btn-white btn-block">Хөрөнгийн зах зээлийн мэргэжилтэн бүртгүүлэх</button>
                  </div>
                </template>
                <template v-else-if="$store.state.app.activeGroup.id != 9233 && $store.state.app.activeGroup.id != 9300">
                  <div class="divider-text">Танд бүртгэл байхгүй юу?</div>
                  <button @click="$router.push({name: 'register'})" class="btn btn-outline-twitter btn-block">Бүртгүүлэх</button>
                </template>
              </template>
               
              <template v-if="$store.state.app.activeGroup.id == 9233">
                <div class="divider-text">эсвэл</div>
                <div class="tx-13 mg-t-20 tx-center">
                  Танд бүртгэл байхгүй юу?
                  <a
                    href="http://help.vetdrug.mn/#/vet-landing-help/45047/1377723"
                    target="_blank"
                    tabindex="5"
                    >Бүртгүүлэх</a
                  >
                </div>
              </template>
              <template
                v-if="
                  $store.state.app.isMobile &&
                  $store.state.app.activeGroup.publicPage != undefined &&
                  $store.state.app.activeGroup.publicPage.has
                "
              >
                <router-link
                  to="/"
                  class="btn btn-brand-01 btn-block text-white"
                  tabindex="5"
                  >Эхлэл</router-link
                >
              </template>
              <template v-if="groupChooser.isSetted">
                <div class="divider-text">тохируулсан байгууллага</div>
                <div class="tx-13 mg-t-20 tx-center">
                  {{ groupChooser.settedOrg.name }}
                  <a
                    @click="manageGroupChooser(true)"
                    class="mg-l-10 bd-l bd-3 pd-l-5"
                  >
                    Солих
                    <feather
                      type="settings"
                      class="mg-l-5 wd-20-f ht-20-f"
                    ></feather>
                  </a>
                </div>
              </template>
              <!-- {{groupChooser.isSetted}} -->

              <div
                v-if="$store.state.app.activeGroup.id == -6126"
                class="mg-t-20 pd-5 bg-white"
              >
                <div class="">
                  <div
                    @click="joinToExam()"
                    role="button"
                    class="pd-10 rounded"
                    style="background-color: rgb(255, 243, 223)"
                  >
                    <div class="d-flex align-items-center">
                      <div class="bg-warning pd-5 rounded">
                        <feather type="pen-tool"></feather>
                      </div>
                      <div class="pd-l-10 lh-3">
                        Хөндлөнгийн үнэлгээний шалгалтад бүртгүүлэх бол
                        <span class="text-uppercase font-weight-bolder"
                          >энд</span
                        >
                        дарна уу
                      </div>
                      <div class="mg-l-auto">
                        <feather type="chevron-right"></feather>
                      </div>
                    </div>
                  </div>
                  <div class="tx-italic tx-12 mg-t-10">
                    (Их, дээд сургуульд нягтлан бодогч мэргэжлээр суралцдаг
                    оюутан, Төсөвт байгууллагын нягтлан бодогч)
                  </div>
                </div>
                <div class="divider-text">бүртгэлтэй бол</div>
                <div class="tx-13 tx-center">
                  Бүртгэлтэй эрхээрээ шалгалт өгөх?
                  <a
                    @click="loginOnModal = true"
                    role="button"
                    class="link text-primary"
                    >Нэвтрэх</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- sign-wrapper -->
      </div>
      <!-- media -->
    </div>
    <!-- container -->
    <b-modal
      :no-close-on-backdrop="true"
      v-model="googleAuthenticator.modal"
      title="Хоёр нөхцөлт баталгаажуулалт"
      hide-footer
      @close="onclose2factor"
    >
      <div class="alert alert-secondary" role="alert">
        Таны Authenticator аапликейшнаас өгж буй зургаан оронтой кодыг оруулна
        уу.
      </div>
      <div class="d-flex">
        <input v-model="googleAuthenticator.code" class="form-control" />
        <a
          @click="verifyTOTP(googleAuthenticator.code)"
          class="btn btn-primary mg-l-10"
          >шалгах</a
        >
      </div>
    </b-modal>

    <b-modal v-model="loginOnModal" title="Нэвтрэх" hide-footer centered>
      <div class="form-group">
        <label v-if="$store.state.app.activeGroup.id == 9132"
          >Багш эсвэл Оюутны код эсвэл И-мэйл хаяг</label
        >
        <label
          v-else-if="
            $store.state.app.activeGroup.id == 9241 ||
            $store.state.app.activeGroup.id == 9249
          "
          >Домэйн</label
        >
        <label v-else>Хэрэглэгчийн нэр эсвэл И-мэйл хаяг</label>
        <input
          tabindex="101"
          v-model="loginModel.username"
          type="text"
          class="form-control"
          :placeholder="`${getLoginPlaceHolder()}`"
        />
      </div>
      <div class="form-group">
        <div class="d-flex justify-content-between mg-b-5">
          <label class="mg-b-0-f">Нууц үг</label>
        </div>
        <input
          tabindex="102"
          v-model="loginModel.password"
          type="password"
          class="form-control"
          placeholder="Нууц үгээ оруулна уу"
        />
      </div>
      <button
        @click="loginFromModal"
        tabindex="103"
        type="submit"
        class="btn btn-brand-02 btn-block"
      >
        Нэвтрэх
      </button>
    </b-modal>

    <b-modal v-model="simpleRegForm.modal" title="Бүртгүүлэх" hide-footer centered>
      <div class="form-group">
        <div class="d-flex justify-content-between mg-b-5">
          <label class="mg-b-0-f">Нэр</label>
        </div>
        <input
          tabindex="201"
          v-model="simpleRegForm.name"
          type="text"
          class="form-control"
          placeholder="Нэр бичнэ үү"
        />
      </div>
      <div class="form-group">
        <div class="d-flex justify-content-between mg-b-5">
          <label class="mg-b-0-f">Утас</label>
        </div>
        <input
          tabindex="210"
          v-model="simpleRegForm.phone"
          type="text"
          class="form-control"
          placeholder="Утас бичнэ үү"
        />
      </div>
      <div class="form-group">
        <label>И-мэйл хаяг</label>
        <input
          tabindex="220"
          v-model="simpleRegForm.mail"
          type="text"
          class="form-control"
          placeholder="И-мэйл хаяг оруулна уу"
        />
      </div>
      <button
        @click="doSimpleReg"
        tabindex="203"
        type="submit"
        class="btn btn-brand-02 btn-block"
      >
        Бүртгүүлэх
      </button>
    </b-modal>

    <b-modal
      title="Үйлчилгээний нөхцөл"
      v-model="privacyPolicyModal"
      no-close-on-backdrop
      scrollable
      hide-header
      size="lg"
    >
      <div class="pd-20">
        <p><strong>НУУЦЛАЛЫН БОДЛОГО</strong></p>
        <p>
          Хэрэглэгчийн хувийн болон, ашиглаж буй бүтээгдэхvvн үйлчилгээтэй
          холбоотой бvх төрлийн мэдээллийн халдашгүй байдлыг хангах, хамгаалах
          нь Динамик платформ ашиглан үйлчилгээ үзүүлэгчийн үүрэг болно.
          "Нууцлалын бодлого" нь Хэрэглэгчийн мэдээллийг хадгалах, хамгаалахтай
          холбоотой хэрэгжүүлэх бодлого юм.
        </p>
        <p><strong>ЕРӨНХИЙ ЗҮЙЛ</strong></p>
        <ol>
          <li>
            Динамик платформыг ашигласнаар таныг уг Нууцлалын бодлогын
            нөхцөлүүдийг зөвшөөрсөн гэж үзнэ. Хуульд өөрчлөлт орох, эсвэл хувийн
            мэдээлэл цуглуулах, ашиглах бидний практик үйл ажиллагаанд өөрчлөлт
            орсон тохиолдолд Динамик платформ нь энэхүү Нууцлалын бодлогод
            өөрчлөлт оруулж болно. Шинэчлэгдсэн нууцлалын бодлогыг
            https://www.gosmart.mn вэб хуудсанд байршуулан тухайн өөрчлөлтийг
            хэрэглэгчдэд мэдэгдэж &ldquo;[Сүүлд шинэчилсэн:]&rdquo; гэх огноог
            өөрчилнө. Нууцлалын бодлогод хийгдсэн өөрчлөлтүүд нь вэб сайтад
            нийтлэгдсэн үеээс хүчин төгөлдөр үйлчилнэ. Хэрэглэгч та шинэчлэгдсэн
            нөхцөлийг вэб сайтад нийтлэгдсэн, эсвэл хэрэглэгчдэд мэдээлснээс
            хойш Динамик платформын үйлчилгээг үргэлжлүүлэн ашиглавал тэдгээрийг
            хүлээн зөвшөөрсөнд тооцогдоно.
          </li>
          <li>
            Хэрэглэгчийн Динамик платформд оруулсан бүх мэдээ, мэдээллийг нууц
            мэдээ мэдээлэлд хамруулна.
          </li>
          <li>
            Мэдээллийн хадгалах хэлбэрээс үл хамааран мэдээ, мэдээллийн нууцыг
            тухай бүр тохирсон арга, хэлбэрээр чандлан хамгаалах, задруулахгүй
            байх бүх арга хэмжээг авна.
          </li>
          <li>
            Хэрэглэгчийн зүгээс өөрийн платформд нэвтрэх хаяг, хувийн мэдээлэл
            болон нууц үгийг чандлан хадгалах, бусдад дамжуулахгүй байх
            үүрэгтэй.
          </li>
        </ol>
        <p><strong>МЭДЭЭЛЛИЙН ТӨРӨЛ</strong></p>
        <ul>
          <li>
            Хэрэглэгчийн бүртгэл үүсгэхтэй холбоотой үүссэн бүх төрлийн мэдээлэл
          </li>
          <li>
            Динамик цахим сургалтын платформ ашиглахтай холбогдон үүссэн бүх
            төрлийн тайлан, статистик, дүн, мэдээ
          </li>
        </ul>
        <p>
          Дээрх бүх төрлийн мэдээллийн аюулгүй байдлыг Хувь хүний нууцын тухай
          болон Кибер аюулгүй байдлын тухай хуульд нийцүүлэн, чандлан хадгалж,
          хөндлөнгийн этгээдэд задруулахгүй, хамгаалах боломжит бүх арга хэмжээг
          авна.
        </p>
        <p><strong>БАТАЛГАА</strong></p>
        <ol>
          <li>
            Динамик платформ ашиглан үйлчилгээ үзүүлэгч нь үйл ажиллагаа явуулах
            хууль ёсны зөвшөөрөлтэй, энэхүү бодлогыг хэрэгжүүлэх, аливаа хэлцэл
            хийх чадвартай байна.
          </li>
          <li>
            Холбогдох хууль тогтоомжид заасан бусад үндэслэл болон, хэрэглэгч
            тал өөрийн нууц мэдээллийг задруулахаар бичгээр зөвшөөрснөөс бусад
            тохиолдолд хэрэглэгчийн нууц мэдээллийг ашиглах болон бусдад гаргаж
            өгч, ашиглуулахгүй.
          </li>
        </ol>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <p><strong>ҮЙЛЧИЛГЭЭНИЙ НӨХЦӨЛ</strong></p>
        <p>
          ДИНАМИК ПЛАТФОРМЫГ СОНГОН АШИГЛАЖ БАЙГАА ТАНД БАЯРЛАЛАА. ДИНАМИК
          ПЛАТФОРМЫН ҮЙЛЧИЛГЭЭНИЙ НӨХЦӨЛ НЬ ҮЙЛЧИЛГЭЭТЭЙ ХОЛБООТОЙ ХАРИЛЦААГ
          ЗОХИЦУУЛНА. ҮЙЛЧИЛГЭЭНИЙ НӨХЦӨЛТЭЙ ТАНИЛЦАЖ, ЗӨВШӨӨРСНӨӨР ҮЙЛЧИЛГЭЭТЭЙ
          ХОЛБООТОЙ ХАРИЛЦААНД ОРОЛЦОХ ЭРХ, ҮҮРЭГ, ХАРИУЦЛАГЫГ ХҮЛЭЭХЭЭР ТАЛУУД
          ТОХИРОЛЦСОНД ТООЦОГДОНО.
        </p>
        <p>
          БИДНИЙ ҮЙЛЧИЛГЭЭГ АШИГЛАХААСАА ӨМНӨ ТА ЭНЭХҮҮ ГЭРЭЭНД ЗААСАН
          НӨХЦӨЛҮҮДИЙГ САЙТАР УНШИЖ ТАНИЛЦАНА УУ.
        </p>
        <p><strong>НЭГ. ЕРӨНХИЙ НӨХЦӨЛ</strong></p>
        <ol>
          <li>
            Үйлчилгээний нөхцөл нь нэг талаас Динамик платформын аюулгүй,
            найдвартай байдлыг ханган Хэрэглэгчийн мэдээллийг хадгалах,
            хамгаалах Үйлчилгээ үзүүлэгчийн, нөгөө талаас Үйлчилгээг ашиглан
            цахим сургалтад хамрагдах Хэрэглэгчийн хооронд үүсэх бүх төрлийн
            харилцааг зохицуулна.
          </li>
          <li>
            Энэхүү үйлчилгээний нөхцөлд дурьдсан нэр томъёог дараахь утгаар
            ойлгоно. Үүнд:
          </li>
        </ol>
        <ul>
          <li>Динамик платформ - цахим сургалтын платформ</li>
          <li>
            Үйлчилгээ - Динамик цахим сургалтын платформыг ашигласнаар авах
            үйлчилгээ
          </li>
          <li>
            Үйлчилгээ үзүүлэгч - Динамик платформоор дамжуулан цахим сургалтын
            үйл ажиллагаа явуулж буй тал
          </li>
          <li>
            Үйлчилгээний нөхцөл - Үйлчилгээтэй холбоотой харилцааг зохицуулах
            баримт бичиг
          </li>
          <li>
            Хэрэглэгч - Динамик платформд бүртгэл үүсгэн ашиглаж буй хувь хүн
            эсвэл, хуулийн этгээдийг төлөөлөгч хүн
          </li>
          <li>Талууд - Үйлчилгээ үзүүлэгч болон үйлчилгээ авч буй хэрэглэгч</li>
          <li>
            Хэрэглэгчийн мэдээлэл - Хэрэглэгчийн Динамик платформд оруулсан
            хувийн мэдээлэл болон, үйлчилгээ авахтай холбоотой үүссэн мэдээлэл
          </li>
        </ul>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <ol start="3">
          <li>
            Тус үйлчилгээний нөхцөл нь хэрэглэгч та танилцан хүлээн зөвшөөрч,
            динамик платформ сайт болон аппликейшн - д бүртгүүлсэн өдрөөс хүчин
            төгөлдөр үйлчилнэ.
          </li>
        </ol>
        <p>&nbsp;</p>
        <ol start="4">
          <li>
            Хэрэглэгч үйлчилгээний нөхцлийг анхааралтай уншиж танилцах үүргээ
            зохих ёсоор гүйцэтгээгүй нь Үйлчилгээний нөхцөл, түүний аливаа
            заалтыг танилцаагүй, мэдээгүй, хүлээн зөвшөөрөхгүй гэж үзэх, эсхүл
            Хэрэглэгчийг аливаа үүрэг, хариуцлагаас чөлөөлөх үндэслэл болохгүй.
          </li>
          <li>
            Динамик платформ нь энэхүү үйлчилгээний нөхцөлд хэдийд ч нэмэлт,
            өөрчлөлт оруулах бүрэн эрхтэй бөгөөд шинэчлэгдсэн Үйлчилгээний
            нөхцөлийг https://www.gosmart.mn вэб хуудсанд байршуулан тухайн
            өөрчлөлтийг хэрэглэгчдэд мэдэгдэж &ldquo;[Сүүлд шинэчилсэн:]&rdquo;
            гэх огноог өөрчилнө. Үйлчилгээний нөхцөлд хийгдсэн өөрчлөлтүүд нь
            вэб сайтад нийтлэгдсэн үеээс хүчин төгөлдөр үйлчилнэ. Хэрэглэгч та
            шинэчлэгдсэн нөхцөлийг вэб сайтад нийтлэгдсэн, эсвэл хэрэглэгчдэд
            мэдээлснээс хойш Динамик платформын үйлчилгээг үргэлжлүүлэн
            ашиглавал тэдгээрийг хүлээн зөвшөөрсөнд тооцогдоно.
          </li>
        </ol>
        <p>&nbsp;</p>
        <p><strong>ХОЁР. ДИНАМИК ПЛАТФОРМЫН ҮЙЛ АЖИЛЛАГАА</strong></p>
        <ol>
          <li>Динамик платформ сайт болон аппликейшн нь :</li>
        </ol>
        <ul>
          <li>
            Контентуудыг хэрэглэгчдэд хүргэж буй платформыг тасралтгүй хөгжүүлэх
          </li>
          <li>
            Төлбөр баталгаажуулах, гишүүнчлэлийн эрхийг найдвартай, шуурхай
            идэвхжүүлэх
          </li>
        </ul>
        <ol start="2">
          <li>
            Вэбсайт болон аппликэйшн нь өдөр бүр 24 цагийн ажиллагаатай байх
            бөгөөд шаардлага гарч түр хугацаанд хаагдах эсвэл засвар хийгдэх
            тохиолдолд систем хариуцсан ажилтан ажлын цагаар боломжит дээд
            хугацаанд засварлах үүрэгтэй.
          </li>
          <li>
            3.&nbsp;Бүртгэлтэй хэрэглэгчдийн хувийн мэдээлэл, төлбөр төлөлт
            болон бүх төрлийн нууцлалыг хоёр тал бүрэн хариуцна.
          </li>
          <li>
            4.&nbsp;Динамик платформ сайт болон аппликейшний бүтээгдэхүүн,
            үйлчилгээ, контент, мэдээллүүд нь үйлчилгээ үзүүлэгчийн өмч бөгөөд,
            зөвшөөрөгдсөнөөс бусад тохиолдолд хуулах, тараах, олшруулах, албан
            зөвшөөрөлгүй ашиглахыг хориглоно.
          </li>
        </ol>
        <p><strong>ГУРАВ. ХЭРЭГЛЭГЧИЙН ЭРХ, ҮҮРЭГ</strong></p>
        <ol>
          <li>
            Өөрийн платформд нэвтрэх хаяг, хувийн мэдээлэл болон нууц үгийг
            чандлан хадгалах, бусдад дамжуулахгүй байх үүрэгтэй.
          </li>
          <li>
            Динамик платформын үйл ажиллагааг илүү сайжруулах, боловсронгуй
            болгохтой холбоотой санал хүсэлтээ илэрхийлэх эрхтэй.
          </li>
          <li>
            Хэрэглэгч нь контент үзэх платформыг ашиглах тоног төхөөрөмж,
            интернэтээр өөрийгөө хангах үүрэгтэй.
          </li>
          <li>
            Платформд байршиж буй контентуудыг тараан байршуулах, хуулбарлахгүй
            байх үүрэгтэй.
          </li>
          <li>
            Бүх хэрэглэгчид тэгш эрх, үүрэгтэй байх бөгөөд ямар нэгэн хэрэглэгч
            бусад хэрэглэгчээс илүү давамгай эрхгүй.
          </li>
          <li>
            Платформ ашиглахад тулгарч буй асуудлуудыг тухай бүрд мэдээллэн
            зөвлөгөө, тусламж авах эрхтэй.
          </li>
        </ol>
      </div>
      <template #modal-footer>
        <label for="pp" class="mg-b-0-f"
          ><input id="pp" type="checkbox" v-model="privacyPolicy" />
          <strong> Би үйлчилгээний нөхцөлийг уншиж танилцан зөвшөөрч байна</strong>
        </label>

        <b-button @click="privacyPolicyUpdate" variant="primary"
          >үргэлжлүүлэх</b-button
        >
      </template>
    </b-modal>
  </div>
  <!-- content -->
</template>
<script>
import "element-ui/lib/theme-chalk/index.css";
import { Message, Notification } from "element-ui";

import { mapActions } from "vuex";
import {
  localSave,
  localRead,
  getRedirectUrl,
  setRedirectUrl,
} from "@/libs/util";
import config from "@/config";
// import { activeKeys } from "@/api/app";

// const { mobApps, mobAppActiveGroup } = config;

import { hasOneOf } from "@/libs/tools";
import { request } from "@/api/all";
const { mobApps } = config;

const crypto = require("crypto");
const base32 = require("hi-base32");

export default {
  data: () => ({
    stfAppDomains:[
      {url: 'zuvlul.stf.gov.mn', desc: '', active: false},
      {url: 'researcher.stf.gov.mn', desc: '', active: false},
      {url: 'project.stf.gov.mn', desc: '', active: false},
      {url: 'startup.stf.gov.mn', desc: '', active: false}
    ],
    simpleRegForm: {
      modal: false,
      name: null,
      phone: null,
      mail: null,
    },
    privacyPolicy: false,
    privacyPolicyModal: false,
    loginOnModal: false,
    groupChooser: {
      list: [],
      show: false,
      isSetted: false,
      settedOrg: {},
    },
    // host: {},
    useFingerPrint: false,
    fingerPrintInstalled: false,
    loginModel: {
      loading: null,
      username: "",
      password: "",
    },
    activeCarousel: 0,
    // childrenSelected: "",
    // childrens: []
    googleAuthenticator: {
      res: null,
      modal: false,
      code: null,
      secret: null,
    },
    coverObj: {
      rdy: false,
      url: "",
    },
  }),
  mounted() {
    if (
      (this.$store.state.app.activeGroup.id == 1104 &&
      this.$store.state.app.isMobile)
      ||
      ((this.$store.state.app.activeGroup.id == 9235 || this.$store.state.app.activeGroup.id == 9290) && this.$store.state.app.isMobile)
    ) {
      this.manageGroupChooser(false);
    }

    require("@/assets/scss/pages/auth.scss");
    // this.host = mobApps.filter(x => x.id == mobAppActiveGroup)[0];
    // if (this.host.children != undefined && this.host.children.length > 0) {
    //   activeKeys({ store: this.$store }).then(res => {
    //     if (res != false) {
    //       this.childrens = res.data.list;
    //     }
    //   });
    // }
    // if (this.$store.state.user.userId != "") {
    //   this.manageRedirect();
    // }

    this.init();

    if(localRead("exmLogin")){
      this.loginOnModal= true;
      window.localStorage.removeItem("exmLogin");
    }
  },
  methods: {
    ...mapActions([
      "handleLogin",
      "handleLoginGolomt",
      "handleUserInfo",
      "handleLoading",
      "handleLogOut",
      "handleDynamicMenuLoaded",
      "handleSnackbar",
      "handleGroupSettings",
      "handleUsersettings",
      "handleGroupDefaultProjects",
      "handleRoutes",
      "handleSignalR",
      "handlePersonalSettings",
      "handleActiveGroup",
    ]),
    doSimpleReg(){
      let _errs=[];
      if(this.simpleRegForm.name==null || this.simpleRegForm.name==""){
        _errs.push('Нэр бичнэ үү');
      }
      if(this.simpleRegForm.phone==null || this.simpleRegForm.phone==""){
        _errs.push('Утас бичнэ үү');
      }
      
      if(this.simpleRegForm.mail==null || this.simpleRegForm.mail==""){
        _errs.push('И-мэйл хаяг оруулна уу');
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if(!emailRegex.test(this.simpleRegForm.mail)){
        _errs.push('И-мэйл хаяг зөв оруулна уу');
      }

      if(_errs.length){
        Message({ message: _errs[0], type: "warning" });
      }else{
        this.handleLoading({ isLoading: true });
        request({
          api: { method: "POST", url: "User/RegisterByToken" },
          data: {
            userOvog: "н",
            userNer: this.simpleRegForm.name,
            userMail: this.simpleRegForm.mail,
            userLogin: this.simpleRegForm.mail,
            
            userPass: null,
            userRegister: null,
            userUtas: this.simpleRegForm.phone,
            privacyPolicy: null,
            position: null,
            address: null,
            partnerId: null,
            isGereetOrg: false,
            isGereet: false,
            isLearning: false,
            userMailOwn: null,

            profileModel: {
              departId: null,
              locTypeId1: null,
              locTypeId3: null,
              locTypeId11: null,
              i6: null,
              i7: null,
              s15: null,
              s6: null,
              s7: null,
              qualityPerc: null,
              locTypeId4: null,
              locTypeIds: [334125]
            },
            loginSimple: true,
          },
          store: this.$store,
        }).then((res) => {
          this.handleLoading({ isLoading: false });
          if (res != false) {
            Notification.success({
              message:
                "Таны бүртгэл амжилттай үүслээ. Таны и-мэйл хаягаар очсон баталгаажуулах кодыг оруулна уу.",
              title: "Амжилттай",
              duration: 30000,
              type: "success",
              position: "top-right",
              offset: 50,
            });
            localSave("activationGroupId", res.mailRenew.groupId);
            localSave("activationUserId", res.mailRenew.userId);
            this.$router.push({
              name: "activation",
              params: { u: res.mailRenew.userId },
            });
          }
        });
      }
    },
    openSimpleRegForm(){
      this.simpleRegForm.modal= true;
    },
    manageGroupChooser(force) {
      if (localRead("settedOrg") && !force) {
        this.groupChooser.settedOrg = JSON.parse(localRead("settedOrg"));
        this.groupChooser.isSetted = true;

        this.setOrg(this.groupChooser.settedOrg);
      } else {
        this.groupChooser.show = true;
        this.handleLoading({ isLoading: true });
        request({
          api: { method: "GET", url: "activeKeys" },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.handleLoading({ isLoading: false });
            //console.log('res.data.list', res.data.list);
            if(this.$store.state.app.activeGroup.id == 9235 || this.$store.state.app.activeGroup.id == 9290){
              this.groupChooser.list = [
                {
                  domain: "railway.gosmart.mn",
                  id: 9235,
                  key: "OorU4s35GE_30FR_ubbdwA",
                  name: "Зүтгүүрийн аж ахуйн алба",
                  ord: 5,
                },
                {
                  domain: "echvod1.gosmart.mn",
                  id: 9290,
                  key: "4PLBfzTFa0O_R_gJ0ub9Ow",
                  name: "ЭЧВОД-1",
                  ord: 10,
                }
              ];
            }else{
              this.groupChooser.list = res.data.list;
            }            
          }
        });
      }
    },
    init() {
      request({
        api: { method: "GET", url: "User/GetHomeSettingsByKey" },
        //key: this.$store.state.app.activeGroup.key,
        params: { key: this.$store.state.app.activeGroup.key },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          let arr = res.settings.filter((x) => x.key == "homeSetting_cover");
          //console.log('res', res, arr);
          if (arr.length > 0 && arr[0].value.length > 0) {
            this.coverObj.rdy = true;
            this.coverObj.url = arr[0].value;
          }
        }
      });
    },
    loginFromModal() {
      //console.log('otp damjuulav');
      this.login(1);
    },
    login(opt) {
      //console.log('otp=> ', opt);
      if (this.loginModel.username.length == 0) {
        this.$bvToast.toast(
          `Хэрэглэгчийн нэр эсвэл И-мэйл хаяг хоосон байна.`,
          { title: "Мэдэгдэл", autoHideDelay: 15000, appendToast: true }
        );
      } else if (this.loginModel.password.length == 0) {
        this.$bvToast.toast(`Нууц үг хоосон байна.`, {
          title: "Мэдэгдэл",
          autoHideDelay: 15000,
          appendToast: true,
        });
      } else {
        if (this.$store.state.app.activeGroup.id == 9249) {
          this.golomtLogin();
        } else {
          //console.log('otp=> ', otp);
          this.doLogin(opt);
        }
      }
      //if(this.$store.state.app.activeGroup.id==9241 ||this.$store.state.app.activeGroup.id==9249){
    },
    checkEnter(e) {
      if (e.keyCode === 13) {
        this.login();
      }
    },
    golomtLogin() {
      this.handleLoading({ isLoading: true });
      request({
        api: { method: "POST", url: "golomt/loginLDAP" },
        data: {
          username: this.loginModel.username,
          password: this.loginModel.password,
          key: this.$store.state.app.activeGroup.key,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.handleLoading({ isLoading: false });
          if (res.result == 1) {
            this.handleLoginGolomt({ token: res.token }).then(() => {
              if (
                this.$store.state.app.activeGroup.id == 9249 &&
                this.$store.state.app.isMobile &&
                this.loginModel.username.toLowerCase() !=
                  "ajiltan01".toLowerCase()
              ) {
                this.googleAuthenticator.res = res;
                this.loginAfter({ result: -200 });
              } else {
                this.loginAfter(res);
              }
            });
          } else if (res.result == 0) {
            this.doLogin();
          }
        }
      });
    },
    doLogin(opt) {
      //console.log("opt=> ", opt);
      this.handleLoading({ isLoading: true });
      this.handleLogin({
        user: this.loginModel.username,
        password: this.loginModel.password,
        //key: _key
        key: this.$store.state.app.activeGroup.key,
      }).then((res) => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          if (
            this.$store.state.app.activeGroup.id == 9249 &&
            this.$store.state.app.isMobile &&
            this.loginModel.username.toLowerCase() != "ajiltan01".toLowerCase()
          ) {
            this.googleAuthenticator.res = res;
            this.loginAfter({ result: -200 });
          } else {
            if (opt != undefined && opt == 1) {
              localSave("tmz_exam", "1");
            }
            this.loginAfter(res);
          }
        }
      });
    },
    loginAfter(res) {
      if (res.result == -900) {
        localSave("activationGroupId", res.mailRenew.groupId);
        localSave("activationUserId", res.mailRenew.userId);
        this.$router.push({
          name: "activation",
          params: { u: res.mailRenew.userId },
        });
      } else if (res.result == -200) {
        request({
          api: { method: "POST", url: "Auth/Post2FactorToken" },
          data: { token: null, isDisabled: false },
          store: this.$store,
        }).then((ares) => {
          if (ares != false) {
            this.googleAuthenticator.secret = ares.data.token;
            this.googleAuthenticator.modal = true;
          } else {
            if (
              this.$store.state.app.activeGroup.id == 9249 &&
              this.$store.state.app.isMobile &&
              this.loginModel.username.toLowerCase() !=
                "ajiltan01".toLowerCase()
            ) {
              this.$bvToast.toast(
                `2 Factor Authentication - г идэвхжүүлнэ үү.`,
                {
                  title: "Мэдэгдэл.",
                  autoHideDelay: 15000,
                  appendToast: true,
                }
              );
            }
          }
        });
      } else {
        this.handleUserInfo({ store: this.$store }).then((irs) => {
          if (irs != false) {
            this.handleGroupSettings({ store: this.$store }).then((stt) => {
              if (stt != false) {
                this.handleUsersettings({ store: this.$store }).then((ustt) => {
                  if (ustt != false) {
                    this.handleGroupDefaultProjects({
                      store: this.$store,
                    }).then((res) => {
                      if (res != false) {
                        this.handleRoutes({ router: this.$router })
                          .then(() => {
                            this.handleSignalR({ store: this.$store })
                              .then(() => {
                                this.handleLoading({ isLoading: false });

                                // if(this.$store.state.app.isMobile && this.hasPermission(["learningadmin", "learningteacher"])){
                                //   this.handleLoading({ isLoading: true });
                                //   this.handleLogOut().then(res => {
                                //     if (res != false) {
                                //       this.handleDynamicMenuLoaded(false);
                                //       this.handleLoading({ isLoading: false });
                                //       this.$bvToast.toast(
                                //         `Админ болон багш эрхээр гар утасны апп-р нэвтрэх боломжгүй.`, { title: "Мэдэгдэл", autoHideDelay: 15000, appendToast: true }
                                //       );
                                //     }
                                //   });
                                // }else{

                                //   this.$router.push("/home");
                                // }
                                //deerh hesgiig 2021-09-24 commentlov Gantumur. bagsh bolon admin n utasnaas orj suragchidt chatlah bolon suragch hesgeer haray geh uyed

                                //console.log()
                                if (
                                  this.$store.state.user.userInfo.privacyPolicy
                                ) {
                                  let redirectUrl = getRedirectUrl();
                                  //console.log(redirectUrl);
                                  if (!redirectUrl) {
                                    //console.log("ene 2")
                                    setRedirectUrl("");
                                    this.$router.push("/home");
                                  } else {
                                    //console.log("ene")
                                    setRedirectUrl("");
                                    this.$router.push(redirectUrl);
                                  }
                                } else {
                                  this.privacyPolicyModal = true;
                                  //show privacy policy modal
                                }
                              })
                              .catch(() => {
                                this.handleLoading({ isLoading: false });
                                this.$bvToast.toast(
                                  `Мессеж хүлээн авах сокетын холболт амжилтгүй боллоо.`,
                                  {
                                    title: "Мэдэгдэл",
                                    autoHideDelay: 15000,
                                    appendToast: true,
                                  }
                                );
                                let redirectUrl = getRedirectUrl();
                                //console.log(redirectUrl);
                                if (!redirectUrl) {
                                  //console.log("ene 2")
                                  setRedirectUrl("");
                                  this.$router.push("/home");
                                } else {
                                  //console.log("ene")
                                  setRedirectUrl("");
                                  this.$router.push(redirectUrl);
                                }
                                //this.manageRedirect();
                              });
                          })
                          .catch((ex) => {
                            //console.log(ex);
                            this.$bvToast.toast(
                              `Алдаатай хүсэлт ирлээ. Системийг ахин ачааллана уу.`,
                              {
                                title: "Мэдэгдэл",
                                autoHideDelay: 15000,
                                appendToast: true,
                              }
                            );
                            this.handleLoading({ isLoading: false });
                          });
                      }
                    });
                  }
                });
              }
            });
          }
        });
      }
    },
    privacyPolicyUpdate() {
      
      if (!this.privacyPolicy) {
        Message({
          message: "Үйлчилгээний нөхцөл зөвшөөрнө үү.",
          type: "warning",
        });
        return false;
      } else {
        this.handleLoading({ isLoading: true });
        request({
          api: { method: "post", url: "Auth/UpdatePrivacyPolicy" },
          store: this.$store,
        }).then((res) => {
          this.handleLoading({ isLoading: false });

          if (res != false) {
            
            let redirectUrl = getRedirectUrl();
            if (!redirectUrl) {
              setRedirectUrl("");
              this.$router.push("/home");
            } else {
              setRedirectUrl("");
              this.$router.push(redirectUrl);
            }
          }
        });

        
      }
    },
    // manageRedirect() {
    //   if(this.hasPermission(["elf_student"])) {
    //     this.$router.push({ name: "elfStudent" });
    //   }
    //   else if (
    //     this.hasPermission([
    //       "learningstudent",
    //       "learningteacher",
    //       "learningadmin",
    //     ])
    //   ) {
    //     if (
    //       this.hasPermission(["learningstudent"]) &&
    //       !this.hasPermission(["learningadmin"]) &&
    //       !this.hasPermission(["learningteacher"])
    //     )
    //       this.$router.push({ name: "lmsParticipant" });
    //     else if (this.hasPermission(["learningadmin", "learningteacher"])) {
    //       this.$router.push({ name: "lmsWelcome" });
    //     } else if (this.hasPermission(["learningadmin"])) {
    //       this.$router.push({ name: "home" });
    //     }
    //   }
    //   else if(this.hasPermission(["stf_proj_sudlaach", "	stf_proj_shinjeech", "stf_proj_admin"])) {
    //     // console.error('hasPermission!!! hasPermission!!! hasPermission!!! ');
    //     if (this.hasPermission(["stf_proj_sudlaach"]) && !this.hasPermission(["stf_proj_shinjeech"]) && !this.hasPermission(["stf_proj_admin"]) )
    //       this.$router.push({ name: "stfParticipant" });
    //     else this.$router.push({ name: "home" });
    //   }else {
    //     this.$router.push({ name: "home" });
    //   }
    //   //this.$router.push({ name: "home" });
    // },
    hasPermission(arr) {
      if (this.$store.state.user.userId == "") return false;
      return hasOneOf(this.$store.state.user.userInfo.access, arr);
    },
    setOrg(g) {
      //#TODO eniig zuv duudah yostoi
      let _conf = mobApps.filter((x) => x.id == g.id)[0];
      this.handleActiveGroup(_conf).then(() => {
        localSave("settedOrg", JSON.stringify(_conf));
        this.groupChooser.settedOrg = g;
        this.groupChooser.isSetted = true;
        this.groupChooser.show = false;
      });

      // if (store.state.app.activeGroup) {
      //   store.dispatch('handleActiveGroup', host);
      // }
    },
    carouselChange(m) {
      if (m > 0) {
        if (this.activeCarousel < 2) {
          this.activeCarousel++;
        } else this.activeCarousel = 0;
      } else {
        if (this.activeCarousel > 0) {
          this.activeCarousel--;
        } else this.activeCarousel = 2;
      }
    },

    //# GOOGLE AUTHENTICATOR
    generateSecret(length = 20) {
      const randomBuffer = crypto.randomBytes(length);
      return base32.encode(randomBuffer).replace(/=/g, "");
    },

    verifyTOTP(token, window = 1) {
      let self = this;
      if (Math.abs(+window) > 10) {
        return false;
      }

      for (let errorWindow = -window; errorWindow <= +window; errorWindow++) {
        const totp = self.generateTOTP(
          self.googleAuthenticator.secret,
          errorWindow
        );
        if (Math.abs(token) === totp) {
          self.loginAfter(self.googleAuthenticator.res);
          return true;
        }
      }

      this.$bvToast.toast(`Код буруу байна.`, {
        title: "Мэдэгдэл",
        autoHideDelay: 15000,
        appendToast: true,
      });
    },
    generateTOTP(secret, window = 0) {
      let self = this;
      const counter = Math.floor(Date.now() / 30000);
      return self.generateHOTP(secret, counter + window);
    },
    generateHOTP(secret, counter) {
      let self = this;
      const decodedSecret = base32.decode.asBytes(secret);
      const buffer = Buffer.alloc(8);
      for (let i = 0; i < 8; i++) {
        buffer[7 - i] = counter & 0xff;
        counter = counter >> 8;
      }

      // Step 1: Generate an HMAC-SHA-1 value
      const hmac = crypto.createHmac("sha1", Buffer.from(decodedSecret));
      hmac.update(buffer);
      const hmacResult = hmac.digest();

      // Step 2: Generate a 4-byte string (Dynamic Truncation)
      const code = self.dynamicTruncationFn(hmacResult);

      // Step 3: Compute an HOTP value
      return code % 10 ** 6;
    },
    dynamicTruncationFn(hmacValue) {
      const offset = hmacValue[hmacValue.length - 1] & 0xf;

      return (
        ((hmacValue[offset] & 0x7f) << 24) |
        ((hmacValue[offset + 1] & 0xff) << 16) |
        ((hmacValue[offset + 2] & 0xff) << 8) |
        (hmacValue[offset + 3] & 0xff)
      );
    },
    getLoginPlaceHolder() {
      let rv = "и-мэйл хаяг эсвэл хэрэглэгчийн ID";
      if (this.$store.state.app.activeGroup.id == 9132) {
        rv = "Багш эсвэл Оюутны код эсвэл И-мэйл хаяг";
      } else if (
        this.$store.state.app.activeGroup.id == 9241 ||
        this.$store.state.app.activeGroup.id == 9249
      ) {
        rv = "Домэйн";
      }
      return rv;
    },
    joinToExam() {
      localSave("tmzExam", 1);
      this.$router.push({ name: "register" });
    },
    onclose2factor() {
      //console.log('onclose2factor');
      this.handleLoading({ isLoading: true });
      this.handleLogOut({ store: this.$store }).then((res) => {
        if (res != false) {
          this.handleLoading({ isLoading: false });
          this.$router.push("/");
        }
      });
    },
  },
};
</script>
